module.exports = __webpack_public_path__ + "static/img/brees-2019-slide-6.0d259ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2019-slide-6.jpg
// module id = uTsY
// module chunks = 1